/**
 * Shared Select content for the predefined unit dropdown.
 * Renders unit options grouped by Weight / Volume / Count.
 * Used inside a shadcn <Select> — consumers provide their own <SelectTrigger>.
 */

import {
  SelectContent,
  SelectGroup,
  SelectItem,
  SelectLabel,
} from '@/components/ui/select';
import { UNIT_GROUPS, UNIT_GROUP_LABELS } from '@/types/units';
import type { UnitGroup } from '@/types/units';

const UNIT_GROUP_KEYS = Object.keys(UNIT_GROUPS) as UnitGroup[];

export function UnitGroupSelectContent() {
  return (
    <SelectContent>
      {UNIT_GROUP_KEYS.map((group) => (
        <SelectGroup key={group}>
          <SelectLabel>{UNIT_GROUP_LABELS[group]}</SelectLabel>
          {UNIT_GROUPS[group].map((unit) => (
            <SelectItem key={unit.value} value={unit.value}>
              {unit.label}
            </SelectItem>
          ))}
        </SelectGroup>
      ))}
    </SelectContent>
  );
}
